"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthSuiteContinueWatchingService = void 0;
var auth_suite_fetch_1 = require("../../auth-suite-fetch");
var AuthSuiteContinueWatchingService = /** @class */ (function () {
    function AuthSuiteContinueWatchingService() {
        var _this = this;
        this.clearPlayheadHistoryForCurrentProfile = function () {
            var clearPlayheadsRoute = "".concat(_this.continueWatchingBaseRoute);
            return auth_suite_fetch_1.authSuiteFetchWithAuthorization.delete({
                path: clearPlayheadsRoute,
            });
        };
        this.continueWatchingBaseRoute = "/continueWatching";
    }
    return AuthSuiteContinueWatchingService;
}());
exports.AuthSuiteContinueWatchingService = AuthSuiteContinueWatchingService;
